import { useEffect, useState } from "react";
import "../../styles/main.scss";
import { UseFormSetValue } from "react-hook-form";

export declare type SelectClasses = {
  select: string;
  select_wrapper: string;
  select_value: string;
  select_arrow: string;
  select_options: string;
  select_option: string;
  select_placeholder: string;
};

interface SelectProps {
  options: string[] | React.ReactNode[];
  value?: any;
  isChangeable: boolean;
  classes?: Partial<SelectClasses>;
  placeholder?: string;
  onChange?: (newValue: any) => void;
  setValue?: UseFormSetValue<any>;
  formName?: string;
}

let currentMenuStateFn: (() => void) | undefined = undefined;

export default function Select({
  options,
  value,
  isChangeable,
  classes,
  placeholder,
  onChange,
  setValue,
  formName,
}: SelectProps) {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedOption, setSelectedOption] = useState(value);

  let [closeState, setCloseState] = useState(true);

  function handleClick() {
    if (currentMenuStateFn) {
      currentMenuStateFn();
    }
    setIsOpen((prev) => !prev);

    currentMenuStateFn = () => setIsOpen(false);
  }

  useEffect(() => {
    setSelectedOption(value);
  }, [value]);

  const choose = (option: any) => {
    setSelectedOption(option);
    if (setValue && formName) {
      setValue(formName, option, { shouldDirty: true });
    }
    setIsOpen(false);
  };

  return (
    <div className={`select ${classes ? classes.select : ""}`}>
      <div
        className={`select_wrapper ${classes ? classes.select_wrapper : ""}`}
        onClick={() => {
          handleClick();
          setIsOpen(!isOpen);
        }}
      >
        {selectedOption ? (
          <div
            className={`select_value ${classes ? classes.select_value : ""}`}
          >
            {selectedOption}
          </div>
        ) : (
          <div
            className={`select_placeholder ${
              classes ? classes.select_placeholder : ""
            }`}
          >
            {placeholder}
          </div>
        )}
        <div
          className={`select_arrow ${
            isOpen && closeState ? "opened" : "closed"
          } ${classes ? classes.select_arrow : ""}`}
        ></div>
      </div>
      <div
        className={`select_options ${
          isOpen && closeState ? "visible" : "hidden"
        } ${classes ? classes.select_options : ""}`}
      >
        {options?.map((option) =>
          isChangeable ? (
            <div
              className={`select_option ${
                classes ? classes.select_option : ""
              }`}
              key={option?.toString()}
              onClick={(e) => {
                choose(option);
              }}
            >
              {option}
            </div>
          ) : (
            option
          )
        )}
      </div>
    </div>
  );
}
